export default __webpack_public_path__ + "static/media/nurse.7f608bdc.svg";